import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatMenuModule } from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MainContentComponent } from './main-content/main-content.component';
import { IzborPrikazaComponent } from './izbor-prikaza/izbor-prikaza.component';
import { AppRoutingModule } from './app-routing.module';
import { FilterComponent } from './sidebar/filter/filter.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Filter2Component } from './sidebar/filter2/filter2.component';
import { Filter4Component } from './sidebar/filter4/filter4.component';
import { Filter1Component } from './sidebar/filter1/filter1.component';
import { Filter3Component } from './sidebar/filter3/filter3.component';
import { Filter5Component } from './sidebar/filter5/filter5.component';
import { Filter6Component } from './sidebar/filter6/filter6.component';
import { SidebarService } from './sidebar/sidebar.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    MainContentComponent,
    IzborPrikazaComponent,
    FilterComponent,
    Filter4Component,
    Filter2Component,
    Filter1Component,
    Filter3Component,
    Filter5Component,
    Filter6Component
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatSliderModule,
    MatMenuModule,
    MatGridListModule,
    MatDividerModule,
    MatTabsModule,
    AppRoutingModule,
    MatCardModule,
    MatSelectModule,
    FlexLayoutModule
    ],
  providers: [
    SidebarService
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export class PizzaPartyAppModule {}
